import { memo } from 'react';
import FJTextToImageRatio from '../view/FJTextToImageRatio';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { setSliceRatio } from '../../../../redux/slices/FJSliceTextToImage';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJTextToImageRatioContainer = memo(function FJTextToImageRatioContainer() {
    useLocalStore();
    const dispatch = useDispatch();
    const curRatio = useSelector(state => state.textToImage.curRatio);

    const changeRatio = useCallback(
        ratio => {
            dispatch(setSliceRatio(ratio.name));
        },
        [dispatch],
    );

    return <FJTextToImageRatio curRatio={curRatio} changeRatio={changeRatio} />;
});

export default FJTextToImageRatioContainer;
